import React from 'react';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import WhyUsSection from '../components/WhyUsSection';
import LatestUpdatesSection from '../components/LatestUpdatesSection';
import SEO from '../components/SEO';

const Home = () => {
  return (
    <div>
      <SEO
        title="Lawandcodeafrica.com — Tech and Commercial Law Commentary in Africa"
        description="Leading tech and commercial law commentary across Africa. Expert analysis at the intersection of technology, commerce, regulation, and legal practice."
        path="/"
      />
      <HeroSection />
      <StatsSection />
      <WhyUsSection />
      <LatestUpdatesSection />
    </div>
  );
};

export default Home;
